import { cn } from '../../utils/cn';
import { useIntegrations } from '../../hooks/useIntegrations';

export function IntegrationsPulseStrip() {
  const { data, isLoading } = useIntegrations();

  if (isLoading || !data) return null;

  return (
    <div className="flex items-center gap-3 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 dark:border-slate-800 dark:bg-slate-800/50">
      {data.map((integration) => (
        <div key={integration.key} className="group relative flex items-center gap-1.5">
          <span
            className={cn(
              'h-1.5 w-1.5 rounded-full',
              integration.connected ? 'bg-pulse-500' : 'bg-slate-300 dark:bg-slate-600',
            )}
          />
          <span className="text-[11px] font-medium text-slate-500 dark:text-slate-400">{integration.label}</span>
          <div className="pointer-events-none absolute left-1/2 top-7 z-50 hidden w-max -translate-x-1/2 rounded-md bg-slate-900 px-2 py-1 text-[11px] text-white group-hover:block dark:bg-slate-700">
            {integration.connected ? `Connected${integration.latencyMs ? ` · ${integration.latencyMs}ms` : ''}` : integration.error ?? 'Disconnected'}
          </div>
        </div>
      ))}
    </div>
  );
}
